import type { EventInterceptorProps } from '@consta/uikit/EventInterceptor'
import type { SpaConfig } from '@core/core/types'
import axios from 'axios'
import { logIfNotTest } from 'common/helpers'
import { constaEventHandler } from 'spa-consta-integration'

const getSpaJson = () => axios.get<SpaConfig>('/spa.json').then(({ data }) => data)

function setSpaScript(data: SpaConfig) {
  window.gpnSpaUrl = data.gpnSpaUrl
  window.gpnCounterId = data.gpnCounterId
  window.apiVersion = '1.0'
  const headEl = document.head
  const counterLoadingScript = document.createElement('script')
  counterLoadingScript.async = true
  counterLoadingScript.src = data.gpnCounterUrl
  headEl.appendChild(counterLoadingScript)

  return counterLoadingScript
}

const initSpa = () => {
  return new Promise(resolve => {
    getSpaJson()
      .then(config => setSpaScript(config))
      .then(script => (script.onload = resolve))
  })
}

// В режиме production сборки включаем SPA. Под production сборкой подразумевается webpack.prod.js, т.е. npm run build
const spaLoaded = PRODUCTION ? initSpa() : Promise.resolve()

/**
 * Тип события в СПА по умолчанию.
 * Что этот значит, и какие еще бывают не задокументировано.
 */
export const defaultSpaEventType = 3

export const sendSpaEvent: SpaEventHandler = (eventType, gpnAnalytics) => {
  const user_id = gpnAnalytics.customparams.find(params => params.as_user_id === true)?.value

  if (user_id) {
    gpnAnalytics.customparams = gpnAnalytics.customparams.filter(
      params => params.as_user_id !== true,
    )
    gpnAnalytics.customparams.push({ name: 'user_id', value: user_id, type: 'STRING' })
    gpnAnalytics.customparams.push({ as_user_id: true, value: user_id })
  }

  if (PRODUCTION) {
    spaLoaded.then(() => window.gpnAnalytics?.sendEvent(eventType, gpnAnalytics))
  } else {
    const gpnAnalyticsJson = JSON.stringify(gpnAnalytics)
    logIfNotTest(`Spa Event: ${eventType} ${gpnAnalyticsJson}`)
  }
}

export const sendSpaConstaEvent = (props: EventInterceptorProps) => {
  if (PRODUCTION) {
    spaLoaded.then(() => {
      if (window.gpnAnalytics) {
        constaEventHandler(props)
      }
    })
  } else {
    const propsReplacer = (key: string, value: object) => (key.startsWith('_') ? undefined : value)
    const propsJson = JSON.stringify(props, propsReplacer)
    logIfNotTest(`Spa Consta Event: ${propsJson}`)
  }
}

export const sendSpaLogin = (userId: string) => {
  sendSpaEvent(defaultSpaEventType, {
    componentid: 'user_login',
    constaeventtype: 'undefined',
    component: 'OTHER',
    customparams: [{ as_user_id: true, value: userId }],
  })
}
